module.exports = __webpack_public_path__ + "static/img/1_2_3_2.3de3fd48.jpg";